import React                from 'react';
import { useTranslate }     from '../../../hooks/use';

export const ErrorPage = () => {
    const t = useTranslate();

    return (
        <div className="error-page-container">
            { t('Error_Page_500_Error_Label') }
        </div>
    );
}
 
export default ErrorPage;